export default function(){
    $('.js-compare-image-slider').cocoen();
}
